import React from "react";

export const MedicalDataLaboratoryIcon: React.FC = () => {
  return (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with Sketch.</desc>
      <defs>
        <path
          d="M12,0 L12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 L24,12 C24,18.627417 18.627417,24 12,24 L12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 L0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z"
          id="path-1"
        ></path>
        <filter
          x="-54.2%"
          y="-45.8%"
          width="208.3%"
          height="208.3%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="4"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="LeftPannel-Patient-0"
          transform="translate(-13.000000, -120.000000)"
        >
          <g
            id="Laboratory-menu-Copy-5"
            transform="translate(14.000000, 122.000000)"
          >
            <g id="Laboratory-icon" transform="translate(7.000000, 4.000000)">
              <g id="Rectangle-Copy-208">
                <use
                  fill="black"
                  fillOpacity="1"
                  filter="url(#filter-2)"
                  xlinkHref="#path-1"
                ></use>
                <use
                  fill="#208CFF"
                  fillRule="evenodd"
                  xlinkHref="#path-1"
                ></use>
              </g>
              <path
                d="M8.07014565,13.9893037 L7.44755,12.9310916 C8.78426632,12.1446389 10.2722723,12.3186241 11.8126422,13.3891163 C12.9600517,14.1865176 14.0617632,14.1865176 15.2506934,13.3843353 L15.9373985,14.4021145 C14.3311154,15.4858886 12.6783349,15.4858886 11.1119737,14.3973335 C9.93857286,13.5818693 8.95760544,13.4671697 8.07014565,13.9893037 Z"
                id="Path-4"
                fill="#FFFFFF"
              ></path>
              <path
                d="M13.5144444,13.7956667 C13.9699282,13.4884799 14.3221284,13.0965579 14.5710556,12.6198889 C14.8199827,12.1432198 14.9444444,11.6347805 14.9444444,11.0945556 C14.9444444,10.4907748 14.7961496,9.93466921 14.4995556,9.42622222 C14.2029615,8.91777524 13.800447,8.51526074 13.292,8.21866667 C12.783553,7.92207259 12.2274475,7.77377778 11.6236667,7.77377778 C11.0198859,7.77377778 10.4637803,7.92207259 9.95533333,8.21866667 C9.44688635,8.51526074 9.04437185,8.91777524 8.74777778,9.42622222 C8.4511837,9.93466921 8.30288889,10.4907748 8.30288889,11.0945556 C8.30288889,11.6347805 8.42735061,12.1432198 8.67627778,12.6198889 C8.92520495,13.0965579 9.27740513,13.4884799 9.73288889,13.7956667 C10.0365447,14.0004578 10.4626558,14.1328652 11.0112222,14.1928889 L11.0112222,17.1626667 L12.2361111,17.1626667 L12.2361111,14.1928889 C12.7846775,14.1328652 13.2107886,14.0004578 13.5144444,13.7956667 Z M11.6236667,6.47088889 C12.4604857,6.47088889 13.2390334,6.68273862 13.9593333,7.10644444 C14.6478553,7.51955762 15.1986646,8.07036693 15.6117778,8.75888889 C16.0354836,9.47918879 16.2473333,10.2577366 16.2473333,11.0945556 C16.2473333,11.8784113 16.0672611,12.6039967 15.7071111,13.2713333 C15.3575538,13.9068921 14.433756,14.6531197 13.539,14.8761111 L13.539,17.8458889 C13.539,18.0259639 13.4754451,18.1795549 13.3483333,18.3066667 C13.2212216,18.4337784 13.0676305,18.4973333 12.8875556,18.4973333 L10.3597778,18.4973333 C10.1797028,18.4973333 10.0261117,18.4337784 9.899,18.3066667 C9.77188825,18.1795549 9.70833333,18.0259639 9.70833333,17.8458889 L9.70833333,14.8761111 C8.83513921,14.606093 7.88977953,13.9068921 7.54022222,13.2713333 C7.18007227,12.6039967 7,11.8784113 7,11.0945556 C7,10.2577366 7.21184973,9.47918879 7.63555556,8.75888889 C8.04866873,8.07036693 8.59947804,7.51955762 9.288,7.10644444 C10.0082999,6.68273862 10.7868477,6.47088889 11.6236667,6.47088889 Z"
                id="lightbulb_outline---material"
                stroke="#FFFFFF"
                strokeWidth="0.1"
                fill="#FFFFFF"
                transform="translate(11.623667, 12.484111) rotate(-180.000000) translate(-11.623667, -12.484111) "
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
